import { combineReducers } from 'redux';
 
// import introSlice from '../../components/Intro/redux/reducer';
import { log } from '../../utils/helpers';
import authReducers from "../../pages/Account/redux/reducers";
import homeReducers from "../../pages/Home/redux/reducers";
import videoReducers from "../../pages/Video/redux/reducers";
import albumReducers from "../../pages/Album/redux/reducers";
import characterReducers from "../../pages/Character/redux/reducers";
import giftboxReducers from "../../pages/Giftbox/redux/reducers";

import awardReducers from "../../pages/Award/redux/reducers";
import videoDetailReducers from "../../pages/Video/redux/reducers/videoDetail";
import videoEmojiReducers from "../../pages/Video/redux/reducers/videoEmoji";
import qnaReducers from "../../pages/Qna/redux/reducers";
import noticeReducers from "../../pages/Notification/redux/reducers";
 let reducer = {
   //  intro: introSlice.reducer,
    authReducers,
    homeReducers,
    videoReducers,
    albumReducers,
    characterReducers,
     giftboxReducers,
    awardReducers,
    videoDetailReducers,
    videoEmojiReducers,
    qnaReducers,
   noticeReducers
 }
 
 // log('root_reducer', 'saga');
 /**
  * Merges the main reducer with the router state and dynamically injected reducers
  */

  // const rootReducer = combineReducers({
  //   reducer
  // });

 export default function createReducer(injectedReducers = {}) {

    const rootReducer = combineReducers({
      ...reducer,
      ...injectedReducers,
    });
 
    return rootReducer;
 }


